module.exports = __webpack_public_path__ + "static/media/info02.f8b61481.png";